import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateMeetingEventCodeFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    !bookWidgetFieldsMasterConfig.meetingEventCodeField?.hide &&
    !bookWidgetFieldsMasterConfig.meetingEventCodeField?.disable
  ) {
    let meetingEventCodeValue = '';
    if (retrieveSearchData?.meetingEventCode) {
      meetingEventCodeValue = retrieveSearchData.meetingEventCode;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      meetingEventCodeField: {
        ...updatedBookWidgetFields.meetingEventCodeField,
        meetingEventCodeValue,
        disable: false,
        hide: false
      }
    };
  }

  return updatedBookWidgetFields;
};
